/**
 * atomberg-sticky-atc.js
 *
 * Layered on top of Horizon's native <sticky-add-to-cart> web component.
 * Two responsibilities:
 *
 *   1. Toggle a `data-in-cart="true|false"` attribute on the sticky element
 *      based on whether the *currently selected variant* is in the cart.
 *      CSS uses that attribute to reveal/hide the "View Cart" button.
 *
 *   2. Wire the "View Cart" button to open Horizon's cart drawer by
 *      programmatically clicking the header cart trigger.
 *
 * Sources of truth for the in-cart check:
 *   - On load:         fetch('/cart.js') against data-current-variant-id
 *   - On cart update:  re-fetch (covers add, qty change, removal)
 *   - On variant flip: re-fetch (the new variant may already be in the cart)
 */
(function () {
  'use strict';

  /** @type {any} */
  var w = window;
  if (w._atombergStickyAtcInit) return;
  w._atombergStickyAtcInit = true;

  /**
   * @param {string} variantId
   * @returns {Promise<boolean>}
   */
  function isVariantInCart(variantId) {
    if (!variantId) return Promise.resolve(false);
    // fresh — a cart:update may have just changed the very line we check.
    var req = w.AtombergCartState
      ? w.AtombergCartState.getCart({ fresh: true })
      : fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
          return r.json();
        });
    return req
      .then(function (/** @type {any} */ cart) {
        if (!cart || !cart.items) return false;
        var vid = String(variantId);
        for (var i = 0; i < cart.items.length; i++) {
          if (String(cart.items[i].variant_id) === vid) return true;
        }
        return false;
      })
      .catch(function () {
        return false;
      });
  }

  /**
   * @param {HTMLElement} root
   */
  function syncFromServer(root) {
    var variantId = root.getAttribute('data-current-variant-id') || '';
    if (!variantId) {
      root.setAttribute('data-in-cart', 'false');
      return;
    }
    isVariantInCart(variantId).then(function (inCart) {
      root.setAttribute('data-in-cart', inCart ? 'true' : 'false');
    });
  }

  /**
   * @param {HTMLElement} root
   */
  function bind(root) {
    syncFromServer(root);

    document.addEventListener('cart:update', function () {
      syncFromServer(root);
    });

    var section = root.closest('.shopify-section');
    if (section) {
      // Re-check after the morph + dataset update lands on the next microtask.
      section.addEventListener('variant:update', function () {
        setTimeout(function () {
          syncFromServer(root);
        }, 0);
      });
    }

    root.addEventListener('click', function (e) {
      var target = e.target;
      if (!(target instanceof Element)) return;
      var btn = target.closest('[data-atomberg-view-cart-btn]');
      if (!btn) return;
      e.preventDefault();
      var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger instanceof HTMLElement) trigger.click();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-atomberg-sticky-atc]').forEach(function (el) {
      var root = /** @type {HTMLElement} */ (el);
      /** @type {any} */
      var anyRoot = root;
      if (anyRoot._atombergStickyAtcBound) return;
      anyRoot._atombergStickyAtcBound = true;
      bind(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
